var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulationPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8699 4.90503C10.8699 6.80141 9.33227 8.33875 7.43589 8.33875C5.53951 8.33875 4.0022 6.80141 4.0022 4.90503C4.0022 3.00865 5.53951 1.47131 7.43592 1.47131C9.33232 1.47131 10.8699 3.00865 10.8699 4.90503ZM7.43637 3.92393C7.43661 3.38214 6.99735 2.94259 6.45527 2.94238C5.91345 2.94238 5.47393 3.38167 5.47369 3.92345C5.47369 4.46551 5.91297 4.90503 6.45479 4.90503C6.99687 4.90503 7.43637 4.46599 7.43637 3.92393Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6026 6.24323C12.4833 8.78759 10.1097 10.0792 7.50005 10.0792C4.89036 10.0792 2.51653 8.78759 0.397503 6.24323C-0.141922 5.59548 -0.131111 4.6521 0.422472 4.0166C2.74324 1.35337 5.10291 0 7.50005 0C9.8972 0 12.2566 1.35337 14.5776 4.0166C15.1312 4.6521 15.1418 5.59546 14.6026 6.24323ZM13.8379 4.66121C11.6872 2.19324 9.57466 0.981101 7.50005 0.981101C5.42546 0.981101 3.31342 2.19324 1.1622 4.66169C0.924922 4.93379 0.920353 5.33826 1.15166 5.61564C3.09582 7.95057 5.20595 9.09858 7.50005 9.09858C9.79417 9.09858 11.9043 7.95057 13.8485 5.61564C14.0797 5.33826 14.0752 4.93382 13.8379 4.66121Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationPreviewIcon);
export default __webpack_public_path__ + "static/media/simulation-preview-icon.db70a35dea7308af536cfedea377b2f4.svg";
export { ForwardRef as ReactComponent };